<template>
  <footer class="footer">
    <div class="container footer__container">
      <a
        href="/"
        class="logo logo--footer"
      />
      <nav class="footer-menu__wrap hidden-xs hidden-sm hidden-md">
        <ul class="footer-menu__list column">
          <li class="footer-menu__item">
            <a
              href="https://support.ringba.com/"
              target="_BLANK"
              class="footer-text text-uppercase footer-menu__item__link"
            >Support</a>
          </li>
          <li class="footer-menu__item">
            <a
              href="https://www.ringba.com/glossary"
              target="_BLANK"
              class="footer-text text-uppercase footer-menu__item__link"
            >Glossary</a>
          </li>
          <li class="footer-menu__item">
            <a
              href="https://www.ringba.com/blog"
              target="_BLANK"
              class="footer-text text-uppercase footer-menu__item__link"
            >Blog</a>
          </li>
          <li class="footer-menu__item">
            <a
              href="https://developers.ringba.com/"
              target="_BLANK"
              class="footer-text text-uppercase footer-menu__item__link"
            >Developers</a>
          </li>
          <li class="footer-menu__item">
            <a
              href="http://status.ringba.com"
              target="_BLANK"
              class="footer-text text-uppercase footer-menu__item__link"
            >System Status</a>
          </li>
          <li class="footer-menu__item">
            <a
              href="https://www.ringba.com/terms"
              target="_BLANK"
              class="footer-text text-uppercase footer-menu__item__link"
            >Terms</a>
          </li>
          <li class="footer-menu__item">
            <a
              href="https://www.ringba.com/privacy"
              target="_BLANK"
              class="footer-text text-uppercase footer-menu__item__link"
            >Privacy</a>
          </li>
          <li class="footer-menu__item">
            <a
              href="https://www.ringba.com/abuse"
              target="_BLANK"
              class="footer-text text-uppercase footer-menu__item__link"
            >Abuse</a>
          </li>
        </ul>
      </nav>
      <div class="contact__wrap">
        <h4 class="footer-text text-uppercase hidden-xs ">
          Call us
        </h4>
        <a
          href="tel:18008245000"
          class="call__link"
        >(800) 824-5000</a>
      </div>
      <div class="social__wrap">
        <h4 class="footer-text text-uppercase hidden-xs">
          Follow us
        </h4>
        <div class="social-list">
          <a
            href="https://www.facebook.com/ringba/"
            target="_BLANK"
            class="social-item"
            title="facebook"
          >
            <i class="fa fa-facebook" />
          </a>
          <a
            href="http://www.twitter.com/ringba"
            target="_BLANK"
            class="social-item"
            title="twitter"
          >
            <i class="fa fa-twitter" />
          </a>
          <a
            href="https://www.youtube.com/channel/UC4fdyv_T6PJMmaFBFJZpQRg"
            target="_BLANK"
            class="social-item"
            title="youtube"
          >
            <i class="fa fa-youtube" />
          </a>
          <a
            href="https://www.linkedin.com/company/ringba/"
            target="_BLANK"
            class="social-item"
            title="linkedin"
          >
            <i class="fa fa-linkedin" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
};
</script>

<style>
</style>